var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPausePlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80051 15.1546V4.53629C8.80051 3.52823 8.42419 3.125 7.47351 3.125H5.077C4.12631 3.125 3.75 3.52823 3.75 4.53629V15.1546C3.75 16.1626 4.12631 16.5659 5.077 16.5659H7.47351C8.42419 16.5659 8.80051 16.1626 8.80051 15.1546Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3005 15.1546V4.53629C16.3005 3.52823 15.9242 3.125 14.9735 3.125H12.577C11.6329 3.125 11.25 3.52823 11.25 4.53629V15.1546C11.25 16.1626 11.6263 16.5659 12.577 16.5659H14.9735C15.9242 16.5659 16.3005 16.1626 16.3005 15.1546Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausePlayer);
export default __webpack_public_path__ + "static/media/pause-player.5930432033fb8cd037154f0ebc98a138.svg";
export { ForwardRef as ReactComponent };